var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 29.4235C27.9659 29.4235 29.9649 27.4245 29.9649 24.9586C29.9649 22.4928 27.9659 20.4938 25.5 20.4938C23.0341 20.4938 21.0352 22.4928 21.0352 24.9586C21.0352 27.4245 23.0341 29.4235 25.5 29.4235Z",
    fill: "#00D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5001 15.8807C31.4948 15.8807 37.0637 16.7409 41.2627 18.1864C46.3218 19.9281 49.4323 22.5681 49.4323 24.9587C49.4323 27.4498 46.1358 30.2544 40.7029 32.0545C36.5956 33.4153 31.1906 34.1257 25.5001 34.1257C19.6658 34.1257 14.1411 33.4589 9.98743 32.0395C4.73233 30.2433 1.56714 27.4023 1.56714 24.9587C1.56714 22.5875 4.53707 19.9679 9.52507 18.2289C13.7397 16.7595 19.4461 15.8807 25.4993 15.8807H25.5001Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5974 20.4458C20.5923 15.2528 24.1194 10.8584 27.4693 7.9431C31.5055 4.43063 35.3464 3.05504 37.4172 4.24916C39.5753 5.49364 40.3579 9.7506 39.2032 15.356C38.331 19.594 36.2453 24.6309 33.4025 29.5604C30.4878 34.6145 27.1503 39.0674 23.846 41.9556C19.6647 45.6107 15.6224 46.9334 13.5055 45.7126C11.4514 44.5289 10.6659 40.6467 11.6513 35.4568C12.4839 31.0718 14.5733 25.6895 17.5965 20.4457L17.5974 20.4458Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6049 29.5737C14.6016 24.3866 12.5568 19.1351 11.7033 14.777C10.6759 9.52597 11.4023 5.51118 13.4712 4.3136C15.6271 3.06546 19.7061 4.51331 23.9856 8.31326C27.2213 11.1862 30.5439 15.5077 33.395 20.4327C36.3181 25.4819 38.5089 30.5973 39.3612 34.9025C40.4396 40.3504 39.5668 44.513 37.4519 45.7373C35.3998 46.9253 31.6446 45.6675 27.6405 42.2218C24.2574 39.3106 20.6378 34.8123 17.6049 29.5736V29.5737Z",
    stroke: "#00D8FF",
    strokeWidth: 2.73408
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.45b0e0e480f5724881701ee579cbe089.svg";
export { ForwardRef as ReactComponent };